/* eslint-disable no-underscore-dangle */
export enum ErrorCode {
	CaptchaInvalid = 'captcha.error',
	RaffleNotFound = 'raffle.notfound',
	RaffleInactive = 'raffle.inactive',
	AnswersInvalid = 'answers.invalid',
	EmailInvalid = 'email.invalid',
	EmailAlreadyRegistered = 'email.already_registered'
}

export default class RaffleServiceError extends Error {
	private readonly _code: ErrorCode | string;

	public constructor(code: ErrorCode | string, message?: string) {
		super(message);
		this._code = code;
	}

	public get code(): ErrorCode | string {
		return this._code;
	}
}
